import React, { useContext } from 'react';
import { LanguageContext } from '../../../context/LanguageContext/LanguageContext';
import { mainBannerIndustriales, mainBannerIndustrialesEn } from '../../../json/services/industriales/mainBannerIndustriales';
import MainBanner from '../../Nosotros/MainBanner/MainBanner';
import KnowService from '../KnowService/KnowService';
import ServiceList from '../ServiceList/ServiceList';
import { serviceListIndustriales, serviceListIndustrialesEn } from '../../../json/services/industriales/serviceListIndustriales';
import ServiceBanner from '../ServicesBanner/ServicesBanner';
import { ServicesBannerIndustriales, ServicesBannerIndustrialesEn } from '../../../json/services/industriales/servicesBannerIndustriales';
import { knowServiceIndustriales, knowServiceIndustrialesEn } from '../../../json/services/industriales/knowServiceIndustriales';

const Industriales = () => {
    const { language } = useContext(LanguageContext);

    const data = language === 'ES'
        ? mainBannerIndustriales[0]
        : mainBannerIndustrialesEn[0];

    const content =  language === 'ES' ? knowServiceIndustriales[0] : knowServiceIndustrialesEn[0]

    const services = language === "ES" ? serviceListIndustriales : serviceListIndustrialesEn;

    const dataServiceBanner = language === 'ES'
        ? ServicesBannerIndustriales[0]
        : ServicesBannerIndustrialesEn[0];

    return (
        <>
            <MainBanner {...data} />
            <KnowService content={content}  />
            <ServiceList services={services} />
            <ServiceBanner dataServiceBanner={dataServiceBanner} />
        </>
    )
}

export default Industriales